<template>
  <div @click="clickItem" :class="[
    'call-info-item',
    { lost: ![0].includes(item.result) && !['laterContact'].includes(listType) },
    { isCalling: item.isCalling },
    { active: item.id === newCurCall.id }
  ]" ref="callInfoItem">
    <div class="header">
      <div class="header-left">
        <span v-if="!['laterContact'].includes(listType)"
          :class="`call-icon iconfont ${CALLOUT_TYPE.includes(item[fieldMapCom.callType]) ? 'icon-huchu_line' : 'icon-huru_line'}`"></span>
        <span class="name" :title="item[fieldMapCom.cleName] ? item[fieldMapCom.cleName] : $t('callPopScreen.unknownClient')">
          <span :style="{ color: isVip ? '#E07E17' : 'unset' }">
            {{ item[fieldMapCom.cleName] || $t('callPopScreen.unknownClient') }}
          </span>
        </span>
        <img v-if="isVip" :src="vipIcon" style="width:14px;height:14px;margin:0 2px" />
        <div v-if="['missCall'].includes(listType)" class="inbound-times">{{ $t('callPopScreen.inboundCall') }}{{ item.inbound_times }}{{ $t('callPopScreen.times') }}</div>
        <SwitchClient :cleId="item.cle_id" @switchclient="onSwitchClient" :clePhone="item[fieldMapCom.clePhone]">
          <el-tooltip effect="dark" :content="$t('callPopScreen.switchClient')" placement="top">
            <div v-if="['todayCall', 'callHistory'].includes(listType)" class="switch-client" @click.stop>
              <span class="iconfont icon-zhuanhuan-line"></span>
            </div>
          </el-tooltip>
        </SwitchClient>
      </div>
      <div class="header-right">
        <div v-if="item.isCalling" class="is-calling-flag">
          <div class="voice-playing" v-if="!isQidian">
            <div class="play play1"></div>
            <div class="play play2"></div>
            <div class="play play3"></div>
            <div class="play play4"></div>
          </div>
          <span class="text">{{ $t('callPopScreen.inCall') }}</span>
        </div>
        <span class="time" v-if="item[fieldMapCom.time]">{{ formatAbbrDate(item[fieldMapCom.time]) }}</span>
      </div>
    </div>
    <div class="content">
      <div class="content-left">
        <div class="num-address">
          <span class="mobile ellipsis-1" v-if="item[fieldMapCom.clePhone]">{{ item[fieldMapCom.clePhone] }}</span>
          <span v-if="item[fieldMapCom.areaName]" class="text-2">（{{ item[fieldMapCom.areaName] }}）</span>
        </div>
        <div class="result">
          <span class="call-duration" v-if="item.result === 0 && item.conn_secs"><span
              class="text">{{ $t('callPopScreen.connected') }}</span>{{ formatTime(item.conn_secs) }}</span>
          <span class="call-duration" v-else-if="item.isCalling"><span class="text">{{ item.result_name }}</span></span>
          <span class="call-duration" v-else-if="item.result_name === $t('callPopScreen.connected')"><span
              class="text">{{ item.result_name }}</span></span>
          <span class="call-duration" v-else>{{ item.result_name }}</span>
        </div>
      </div>
      <div class="content-right">
        <el-tooltip effect="dark" :content="$t('callPopScreen.callOut')" placement="top">
          <span @click.stop="callPhone(item[fieldMapCom.clePhone])" class="iconfont icon-hujiao-fill"></span>
        </el-tooltip>
      </div>
    </div>
    <div class="bottom">
      <template v-if="['todayCall', 'callHistory'].includes(listType)">
        <div v-if="ticket.enable" :class="['record', 'ticket-record', { isNoRecord: !ticketIsFilled() }]">{{
          ticketIsFilled() ? $t('callPopScreen.ticketFilled') : $t('callPopScreen.ticketSupplement') }}</div>
        <div v-if="contactRecord.enable"
          :class="['record', 'contact-record', { isNoRecord: !contactRecordIsFilled() }]">{{ contactRecordIsFilled() ?
            $t('callPopScreen.contactRecordFilled') : $t('callPopScreen.contactRecordSupplement') }}</div>
      </template>
      <template v-if="['missCall'].includes(listType)">
        <div :class="['miss-call-deal-status', 'miss-call-deal-status-' + item.deal_status]">{{ item.deal_status_name }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { updateDealStatus, getPhoneCallId, updateLaterSolve } from "@/api/ektv3";
import SwitchClient from '../switchClient'
import { signal } from "@/utils/index";
import vipIcon from '@/assets/images/cle_grade_vip.png'

const defaultFieldMap = {
  cleName: 'cle_name',
  clePhone: 'cus_phone',
  cleId: 'cle_id',
  areaName: 'area_name',
  time: 'start_time',
  callType: 'call_type'
}
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    fieldMap: {
      type: Object,
      default() {
        return {}
      }
    },
    listType: {
      type: String,
      default: ''
    }
  },
  components: {
    SwitchClient
  },
  inject: ['curCall', 'setCurCall', 'businessConfig', 'fillTicketCallIds', 'fillContactCallIds'],
  data() {
    return {
      CALLOUT_TYPE: [1], // 通话类型。从座席角度看，call_type=1 为呼出，其它均为呼入；
      vipIcon,
    }
  },
  computed: {
    fieldMapCom() {
      return { ...defaultFieldMap, ...this.fieldMap }
    },
    newCurCall() {
      return this.curCall()
    },
    newBusinessConfig() {
      return this.businessConfig()
    },
    contactRecord() {
      return this.newBusinessConfig.contact_record || {}
    },
    ticket() {
      return this.newBusinessConfig.ticket || {}
    },
    newFillTicketCallIds() {
      return this.fillTicketCallIds()
    },
    newFillContactCallIds() {
      return this.fillContactCallIds()
    },
    // 客户是否是vip true或者false
    isVip() {
      try {
        return this.item.client_info.cle_is_vip
      } catch (error) {
        return false
      }
    },
    isQidian() {
      return location.hash.includes('qidian/admin') || location.hash.includes('qidian/agent')
    }
  },
  mounted() {
    if (this.item.isCalling && this.$refs.callInfoItem) {
      this.$refs.callInfoItem.scrollIntoView({ behavior: 'smooth' })
    }
  },
  methods: {
    callPhone(phone) {
      const { my: { ektv3_page } } = this._config.URL;
      if (['missCall'].includes(this.listType)) {
        updateDealStatus(ektv3_page, { id: this.item.id }).finally(() => {
          this.$emit('changegroup', 2)
        })
        // 打电话
        // signal.dialByTabMessage(phone);
        window.postMessage(
          JSON.stringify({
            type: 2,
            phone: phone
          }),
          '*'
        )
      } else if (['laterContact'].includes(this.listType)) {
        getPhoneCallId(ektv3_page, { phone: this.item.phone, extId: this.item.extId }).then(res => {
          if (res.code == 0) {
            updateLaterSolve(ektv3_page, { id: this.item.id, call_id: res.data.callId }).then(res => {
              if (res.code == 0) {
                this.$emit('changegroup', 1)
              }
            })
          }
        })
      } else {
        // 打电话
        // signal.dialByTabMessage(phone);
        window.postMessage(
          JSON.stringify({
            type: 2,
            phone: phone
          }),
          '*'
        )
      }
    },
    formatAbbrDate(timestamp) {
      if (!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(timestamp)) {
        timestamp = timestamp * 1000
      }
      const farmat = 'YYYY-MM-DD HH:mm:ss'
      if (['laterContact'].includes(this.listType)) {
        return dayjs(timestamp).format(farmat)
      }
      // 当天
      if (dayjs().isSame(dayjs(timestamp), 'day')) {
        return dayjs(timestamp).format('HH:mm:ss')
      }
      // 昨天
      if (dayjs().isSame(dayjs(timestamp + 24 * 60 * 60 * 1000), 'day')) {
        return this.$t('callPopScreen.yesterday')
      }
      return dayjs(timestamp).format(farmat)
    },
    formatTime(second) {
      if (!second) return
      second = Number(second)
      const d = parseInt(second / (60 * 60 * 24))
      const h = parseInt(second % (60 * 60 * 24) / (60 * 60))
      const m = parseInt(second % (60 * 60) / 60)
      const s = parseInt(second % 60)
      return `${d ? (d + this.$t('callPopScreen.day')) : ''}${h ? (h + this.$t('callPopScreen.hour')) : ''}${m ? (m + this.$t('callPopScreen.minute')) : ''}${s ? (s + this.$t('callPopScreen.second')) : ''}`
    },
    clickItem() {
      this.setCurCall({
        itemType: this.listType,
        id: this.item.id,
        cle_id: this.item[this.fieldMapCom.cleId],
        cle_name: this.item[this.fieldMapCom.cleName],
        cle_phone: this.item[this.fieldMapCom.clePhone],
        call_id: this.item.call_id,
        call_type: this.item.call_type
      })
    },
    onSwitchClient(item) {
      const clientInfo = {
        id: this.item.id,
        [this.fieldMapCom.cleId]: item.id,
        [this.fieldMapCom.cleName]: item.cle_name,
        [this.fieldMapCom.clePhone]: item.cle_phone
      }
      this.setCurCall({
        itemType: this.listType,
        id: this.item.id,
        cle_id: item.id,
        cle_name: item.cle_name,
        cle_phone: item.cle_phone,
        call_id: this.item.call_id,
        call_type: this.item.call_type
      }, true)
      this.$emit('switchclient', clientInfo)
    },
    ticketIsFilled() {
      return this.newFillTicketCallIds.includes(this.item.call_id) || this.item.ticket_submitted == 2
    },
    contactRecordIsFilled() {
      return this.newFillContactCallIds.includes(this.item.call_id) || this.item.is_contact_record_submitted
    }
  }
}
</script>

<style lang="less" scoped>
.call-info-item {
  position: relative;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    bottom: 0px;
    display: block;
    width: calc(100% - 24px);
    height: 1px;
    background: #EBEDF0;
  }

  &.lost {
    .header {
      &-left {

        .call-icon,
        .name {
          color: #FF4D4F;
        }
      }
    }

    .content {
      &-left {
        .result {
          .call-duration {
            color: #FF4D4F;

            .text {
              color: #FF4D4F;
            }
          }
        }
      }
    }
  }

  &:hover {
    background: #F2F3F5;
  }

  &.active {
    background: #E6F8FF;
  }

  &.isCalling {
    // background: #E6F8FF;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 22px;

    &-left {
      display: flex;
      align-items: center;
      gap: 2px;

      .iconfont {
        font-size: 14px;
        color: #969799;
        font-weight: bold;
      }

      .name {
        display: inline-block;
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #323233;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
      }

      .inbound-times {
        padding: 0 4px;
        line-height: 20px;
        border-radius: 2px;
        background: #FBF1D2;
        color: #dc9b02;
        font-size: 12px;
      }

      .switch-client {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;

        .iconfont {
          font-size: 14px;
        }
      }
    }

    &-right {
      display: flex;
      align-items: center;

      .is-calling-flag {
        display: flex;
        align-items: center;
        gap: 3px;
        margin-right: 6px;
        padding: 4px 8px;
        color: #fff;
        border-radius: 20px;
        font-size: 12px;
        background: #0090FF;

        .voice-playing {
          display: flex;
          justify-content: space-between;
          gap: 2px;
          transform: rotate(180deg);
          height: 10px;

          .play {
            background: #fff;
          }

          .play1 {
            width: 1px;
            height: 4px;
            animation: paly-bar-playing1 .5s .5s linear infinite alternate;
          }

          .play2 {
            width: 1px;
            height: 6px;
            animation: paly-bar-playing2 .5s .5s linear infinite alternate;
          }

          .play3 {
            width: 1px;
            height: 10px;
            animation: paly-bar-playing3 .5s .5s linear infinite alternate;
          }

          .play4 {
            width: 1px;
            height: 6px;
            animation: paly-bar-playing4 .5s .5s linear infinite alternate;
          }

          @keyframes paly-bar-playing1 {
            0% {
              height: 4px;
            }

            100% {
              height: 10px;
            }
          }

          @keyframes paly-bar-playing2 {
            0% {
              height: 6px;
            }

            100% {
              height: 8px;
            }
          }

          @keyframes paly-bar-playing3 {
            0% {
              height: 10px;
            }

            100% {
              height: 6px;
            }
          }

          @keyframes paly-bar-playing4 {
            0% {
              height: 6px;
            }

            100% {
              height: 10px;
            }
          }
        }
      }

      .time {
        color: #969799;
        font-size: 12px;
      }
    }
  }

  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-left {
      display: flex;
      flex-direction: column;

      .num-address {
        color: #646566;
        font-size: 12px;
        line-height: 20px;
      }

      .result {
        line-height: 20px;

        .call-duration {
          color: #969799;
          font-size: 12px;

          .text {
            margin-right: 4px;
            color: #34CB82;
          }
        }
      }
    }

    &-right {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      cursor: pointer;

      .iconfont {
        font-size: 18px;
        color: #0090FF;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .bottom {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 4px;

    .record {
      position: relative;
      margin-top: 4px;
      padding: 0 7px;
      border-radius: 4px;
      border: 1px solid #9EC9FA;
      background: #E6F8FF;
      color: #0074d9;
      font-family: "PingFang SC";
      font-size: 12px;
      line-height: 20px;

      &.contact-record {
        color: #08979C;
        background: #E6FFFB;
      }

      &.isNoRecord {
        background: #FFF1F0;
        color: #CF1322;
        border: 1px solid #FFA39E;
        // &::after {
        //   content: '';
        //   position: absolute;
        //   right: 0;
        //   top: 0;
        //   transform: translate(50%, -50%);
        //   display: block;
        //   width: 6px;
        //   height: 6px;
        //   border-radius: 50%;
        //   background: #FF4D4F;
        // }
      }
    }

    .miss-call-deal-status {
      display: flex;
      align-items: center;
      height: 20px;
      margin-top: 4px;
      padding: 0 7px;
      border-radius: 4px;
      border: 1px solid #D9D9D9;
      background: #F7F8FA;
      color: #323233;
      font-size: 12px;

      &-0 {
        color: #CF1322;
        border: 1px solid #FFA39E;
        background: #FFF1F0;
      }

      &-3 {
        color: #0074D9;
        border: 1px solid #9EC9FA;
        background: #E6F8FF;
      }

      &-1 {
        color: #08979C;
        border: 1px solid #87E8DE;
        background: #E6FFFB;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/callPopScreenTab/callInfoItem/index.vue